// extracted by mini-css-extract-plugin
module.exports = {"root":"SalesGoals_root__2fU_Y"};